// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2FMv8","header":"MergedInvoice_header__1PBI3"};